import { z } from 'zod';
/** Only User identifiers use the native UUID v4 contract. */
export const userId = z.uuid({ version: 'v4' }).transform((value) => value.toLowerCase());
//# sourceMappingURL=user-id.js.map